import Page from '../../components/templates/Page'
import Section from '../../components/elements/Section'
import Container from '../../components/elements/Container'
import styles from './styles.module.scss'
import Column from '../../components/layout/Column'
import Columns from '../../components/layout/Columns'
import { useResponsive } from '../../providers/ResponsiveContext'
import Map from '../../components/pages/single-property/Map'
import Button from '../../components/elements/Button'
import { default as ContactSection } from '/components/pages/common/Contact'
import IconExternal from '/public/icons/icon-external.svg'
import axios from '/components/configs/axios'
import headerTranslation from '/components/general/Header/headerTranslation'
import footerTranslation from '/components/general/Footer/footerTranslations'
import cache from 'memory-cache'
import SocialConnect from '../../components/custom/SocialConnect'
import contactTranslation from '/components/pages/common/Contact/contactTranslations'
import contactUsTranslations from '../../components/pages/contact-us/contactUsTranslations'
import { useRouter } from 'next/router'

export const getStaticProps = async ({ locale }) => {
  const pageData = await axios
    .get('info/contact')
    .then((res) => res.data[locale])
    .catch((err) => {
      console.error(err)
    })

  let headerDataTranslation = cache.get('headerTranslations')
  if (!headerDataTranslation) {
    headerDataTranslation = await headerTranslation()
    cache.put('headerTranslations', headerDataTranslation)
  }

  // caching for footer translations
  let footerDataTranslation = cache.get('footerTranslations')
  if (!footerDataTranslation) {
    footerDataTranslation = await footerTranslation()
    cache.put('footerTranslations', footerDataTranslation)
  }

  let contactFormTranslationData = cache.get('contactFormTranslations')
  if (!contactFormTranslationData) {
    contactFormTranslationData = await contactTranslation()
    cache.put('contactFormTranslations', contactFormTranslationData)
  }

  let contactUsTranslationData = cache.get('contactUsTranslationData')
  if (!contactUsTranslationData) {
    contactUsTranslationData = await contactUsTranslations()
    cache.put('contactUsTranslationData', contactUsTranslationData)
  }

  return {
    props: {
      pageData: pageData,
      translations: contactUsTranslationData,
      headerTranslation: headerDataTranslation,
      footerTranslation: footerDataTranslation,
      contactTranslation: contactFormTranslationData
    },
    revalidate: 300
  }
}

const Contact = ({
  pageData,
  headerTranslation,
  footerTranslation,
  ctaTranslation,
  contactTranslation,
  translations
}) => {
  const { isMobile } = useResponsive()
  const router = useRouter()

  return (
    <Page
      headerTranslation={headerTranslation}
      footerTranslation={footerTranslation}
      ctaTranslation={ctaTranslation}
      footer={false}
      meta={{
        title: translations.seo.title[router.locale],
        description: translations.seo.description[router.locale]
      }}
    >
      <Section>
        <Container>
          <h1>{translations.page.title[router.locale]}</h1>

          <p className={styles.subtitle}>
            {translations.page.subtitle[router.locale]}
          </p>
        </Container>
      </Section>

      <div className={styles.separator}>
        <Container>
          <div className={styles.separator__line}></div>
        </Container>
      </div>

      <Section>
        <Container>
          <Columns>
            <Column spans={isMobile ? 12 : 4}>
              <div className={styles.label}>
                {translations.page.call[router.locale]}
              </div>

              <a
                className={styles.link}
                rel="nofollow"
                href="tel:+1 213-805-0840"
              >
                +1 213-805-0840
              </a>
            </Column>

            <Column spans={isMobile ? 12 : 4}>
              <div className={styles.label}>
                {translations.page.email[router.locale]}
              </div>

              <a
                className={styles.link}
                rel="nofollow"
                href="mailto: reservations@sxmsir.com"
              >
                reservations@sxmsir.com
              </a>
            </Column>

            <Column spans={isMobile ? 12 : 4}>
              <div className={styles.label}>
                c{translations.page.connect[router.locale]}
              </div>

              <SocialConnect />
            </Column>
          </Columns>
        </Container>
      </Section>

      <Section separator className={styles.section}>
        <Container>
          <div className={styles.label}>
            {translations.page.driving[router.locale]}
          </div>

          <div className={styles.directions}>
            <Button
              variant={['label']}
              target="_blank"
              className={styles.button}
              href="https://www.google.com/maps/place/St.+Maarten+Sotheby's+International+Realty/@18.0526657,-63.1387348,17z/data=!3m1!4b1!4m5!3m4!1s0x8c0e6914e99b639b:0x4f2f113153a2f916!8m2!3d18.0526657!4d-63.1365461"
            >
              <IconExternal />
              Cupecoy, Sint Maarten
            </Button>

            <Button
              variant={['label']}
              target="_blank"
              className={styles.button}
              href="https://www.google.com/maps/place/18%C2%B003'37.6%22N+63%C2%B005'15.0%22W/@18.0604474,-63.0880504,19z/data=!4m5!3m4!1s0x0:0xae19e4785ba1578b!8m2!3d18.0604474!4d-63.0875019"
            >
              <IconExternal />
              Bellevue, St. Martin
            </Button>
          </div>

          <Map
            points={[
              { lat: '18.0526657', lng: '-63.1365461' },
              { lat: '18.06044735739605', lng: '-63.08750191132895' }
            ]}
          />
        </Container>
      </Section>

      <ContactSection
        translations={contactTranslation}
        staff={pageData}
        separator={false}
        variant={['general']}
      />
    </Page>
  )
}

export default Contact
